export default {
    "C3L-00967":{
        "age":69,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1494.0,
        "PFS_event_status":1.0,
        "progression_free_survival":461.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":2.148059306,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1494.0,
        "Progression Free Survival Time":461.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-00989":{
        "age":57,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":336.0,
        "PFS_event_status":0.0,
        "progression_free_survival":336.0,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":15.34644432,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":336.0,
        "Progression Free Survival Time":336.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-01063":{
        "age":84,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":285.0,
        "PFS_event_status":1.0,
        "progression_free_survival":73.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":8.857976519,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":285.0,
        "Progression Free Survival Time":73.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-02102":{
        "age":68,
        "sex":"Male",
        "tumor_stage":null,
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":2000.0,
        "PFS_event_status":0.0,
        "progression_free_survival":2000.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":34.39109384,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":2000.0,
        "Progression Free Survival Time":2000.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-02615":{
        "age":84,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":1447.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1447.0,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":112.4741569,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1447.0,
        "Progression Free Survival Time":1447.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-02622":{
        "age":42,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1428.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1428.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":9.588759582,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1428.0,
        "Progression Free Survival Time":1428.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-02647":{
        "age":69,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1805.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1805.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":4.163248964,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1805.0,
        "Progression Free Survival Time":1805.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-03362":{
        "age":41,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":137.0,
        "PFS_event_status":0.0,
        "progression_free_survival":137.0,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":1.793740245,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":137.0,
        "Progression Free Survival Time":137.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-03364":{
        "age":54,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":5.0,
        "PFS_event_status":0.0,
        "progression_free_survival":5.0,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":5.270496029,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":5.0,
        "Progression Free Survival Time":5.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-03367":{
        "age":71,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":560.0,
        "PFS_event_status":0.0,
        "progression_free_survival":560.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":1.240116713,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":560.0,
        "Progression Free Survival Time":560.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-03374":{
        "age":83,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":669.0,
        "PFS_event_status":0.0,
        "progression_free_survival":669.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":9.522324758,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":669.0,
        "Progression Free Survival Time":669.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-03377":{
        "age":73,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1109.0,
        "PFS_event_status":1.0,
        "progression_free_survival":274.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":11.80325371,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1109.0,
        "Progression Free Survival Time":274.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-03381":{
        "age":78,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":7.0,
        "PFS_event_status":0.0,
        "progression_free_survival":7.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":6.444177918,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":7.0,
        "Progression Free Survival Time":7.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-03382":{
        "age":71,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1111.0,
        "PFS_event_status":1.0,
        "progression_free_survival":1105.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":21.54702788,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"mutant",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1111.0,
        "Progression Free Survival Time":1105.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-04011":{
        "age":58,
        "sex":"Female",
        "tumor_stage":null,
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":465.0,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":1.683015539,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":null,
        "Overall Survival Time":465.0,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-04207":{
        "age":82,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1025.0,
        "PFS_event_status":1.0,
        "progression_free_survival":297.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":29.87352581,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"mutant",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1025.0,
        "Progression Free Survival Time":297.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-04212":{
        "age":76,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":356.0,
        "PFS_event_status":1.0,
        "progression_free_survival":356.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":106.4728778,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":356.0,
        "Progression Free Survival Time":356.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3L-04331":{
        "age":87,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":364.0,
        "PFS_event_status":1.0,
        "progression_free_survival":364.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":5.824119561,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":364.0,
        "Progression Free Survival Time":364.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-04732":{
        "age":83,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":690.0,
        "PFS_event_status":1.0,
        "progression_free_survival":690.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":16.96302503,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":690.0,
        "Progression Free Survival Time":690.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-04733":{
        "age":78,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1390.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1390.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":29.2756124,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1390.0,
        "Progression Free Survival Time":1390.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-04739":{
        "age":70,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":25.0,
        "PFS_event_status":1.0,
        "progression_free_survival":25.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":6.931366626,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":25.0,
        "Progression Free Survival Time":25.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3L-04760":{
        "age":83,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":494.0,
        "PFS_event_status":1.0,
        "progression_free_survival":320.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":8.547947341,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":494.0,
        "Progression Free Survival Time":320.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-04787":{
        "age":90,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":678.0,
        "PFS_event_status":1.0,
        "progression_free_survival":623.0,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":9.123715815,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":678.0,
        "Progression Free Survival Time":623.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05027":{
        "age":64,
        "sex":"Male",
        "tumor_stage":null,
        "tissue_level":"Primary",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":309.0,
        "PFS_event_status":1.0,
        "progression_free_survival":241.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":0.885797652,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":309.0,
        "Progression Free Survival Time":241.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05175":{
        "age":62,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":374.0,
        "PFS_event_status":1.0,
        "progression_free_survival":320.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":6.776352037,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"mutant",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":374.0,
        "Progression Free Survival Time":320.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3L-05206":{
        "age":78,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1015.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1015.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":3.631770373,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1015.0,
        "Progression Free Survival Time":1015.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05229":{
        "age":82,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Deceased",
        "event_status":1.0,
        "overall_survival":994.0,
        "PFS_event_status":1.0,
        "progression_free_survival":502.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":15.83363303,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"wildtype",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":994.0,
        "Progression Free Survival Time":502.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-05235":{
        "age":57,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":991.0,
        "PFS_event_status":0.0,
        "progression_free_survival":991.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":10.67386171,
        "BRAF_hotspot":"V600R",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":991.0,
        "Progression Free Survival Time":991.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05259":{
        "age":82,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":158.0,
        "PFS_event_status":1.0,
        "progression_free_survival":158.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":8.282208046,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":158.0,
        "Progression Free Survival Time":158.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05261":{
        "age":40,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living|Deceased",
        "event_status":1.0,
        "overall_survival":1294.0,
        "PFS_event_status":1.0,
        "progression_free_survival":68.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":6.4884678,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1294.0,
        "Progression Free Survival Time":68.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05262":{
        "age":53,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":449.0,
        "PFS_event_status":1.0,
        "progression_free_survival":303.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":2.790262604,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":449.0,
        "Progression Free Survival Time":303.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05286":{
        "age":50,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1433.0,
        "PFS_event_status":1.0,
        "progression_free_survival":842.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":1.793740245,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1433.0,
        "Progression Free Survival Time":842.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05290":{
        "age":73,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":607.0,
        "PFS_event_status":1.0,
        "progression_free_survival":77.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":1.129392006,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":607.0,
        "Progression Free Survival Time":77.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05299":{
        "age":72,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1749.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1749.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":14.12847255,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1749.0,
        "Progression Free Survival Time":1749.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05302":{
        "age":72,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Deceased",
        "event_status":1.0,
        "overall_survival":938.0,
        "PFS_event_status":1.0,
        "progression_free_survival":130.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":1.793740245,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":938.0,
        "Progression Free Survival Time":130.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05362":{
        "age":67,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1365.0,
        "PFS_event_status":1.0,
        "progression_free_survival":1264.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":3.299596253,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1365.0,
        "Progression Free Survival Time":1264.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05517":{
        "age":75,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1033.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1033.0,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":4.362553436,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1033.0,
        "Progression Free Survival Time":1033.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05518":{
        "age":80,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":372.0,
        "PFS_event_status":0.0,
        "progression_free_survival":372.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":1.040812241,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":372.0,
        "Progression Free Survival Time":372.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05527":{
        "age":68,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":23.00859401,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05554":{
        "age":74,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":712.0,
        "PFS_event_status":0.0,
        "progression_free_survival":712.0,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":12.88835584,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"G13",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":712.0,
        "Progression Free Survival Time":712.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05556":{
        "age":71,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":56.0,
        "PFS_event_status":0.0,
        "progression_free_survival":56.0,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":0.952232476,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":56.0,
        "Progression Free Survival Time":56.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05598":{
        "age":75,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":974.0,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":5.846264503,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":null,
        "Overall Survival Time":974.0,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05638":{
        "age":76,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":974.0,
        "PFS_event_status":1.0,
        "progression_free_survival":229.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":9.699484289,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":974.0,
        "Progression Free Survival Time":229.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05644":{
        "age":70,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":963.0,
        "PFS_event_status":1.0,
        "progression_free_survival":320.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":11.29392006,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP2",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":963.0,
        "Progression Free Survival Time":320.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05781":{
        "age":61,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1442.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1442.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":2.148059306,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1442.0,
        "Progression Free Survival Time":1442.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05839":{
        "age":87,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1126.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1126.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":5.713394855,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1126.0,
        "Progression Free Survival Time":1126.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-05973":{
        "age":69,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":615.0,
        "PFS_event_status":1.0,
        "progression_free_survival":615.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":1.395131302,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":615.0,
        "Progression Free Survival Time":615.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-05987":{
        "age":79,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":262.0,
        "PFS_event_status":1.0,
        "progression_free_survival":176.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":3.144581664,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":262.0,
        "Progression Free Survival Time":176.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06015":{
        "age":85,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":631.0,
        "PFS_event_status":1.0,
        "progression_free_survival":631.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":2.524523308,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":631.0,
        "Progression Free Survival Time":631.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06017":{
        "age":72,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":228.0,
        "PFS_event_status":1.0,
        "progression_free_survival":101.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":8.902266402,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":228.0,
        "Progression Free Survival Time":101.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Lysosome high"
    },
    "C3L-06019":{
        "age":75,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":989.0,
        "PFS_event_status":0.0,
        "progression_free_survival":989.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"Yes",
        "TMB":1.040812241,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"mutant",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":989.0,
        "Progression Free Survival Time":989.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-06020":{
        "age":69,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":166.0,
        "PFS_event_status":1.0,
        "progression_free_survival":53.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":10.43026735,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":166.0,
        "Progression Free Survival Time":53.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-06023":{
        "age":67,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":964.0,
        "PFS_event_status":0.0,
        "progression_free_survival":964.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":9.168005697,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"mutant",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":964.0,
        "Progression Free Survival Time":964.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06025":{
        "age":71,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":604.0,
        "PFS_event_status":0.0,
        "progression_free_survival":604.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":5.890554385,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":604.0,
        "Progression Free Survival Time":604.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06028":{
        "age":59,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":285.0,
        "PFS_event_status":1.0,
        "progression_free_survival":186.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"Yes",
        "TMB":7.374265452,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":285.0,
        "Progression Free Survival Time":186.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06091":{
        "age":45,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":972.0,
        "PFS_event_status":0.0,
        "progression_free_survival":972.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":5.359075794,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":972.0,
        "Progression Free Survival Time":972.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06096":{
        "age":63,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":968.0,
        "PFS_event_status":0.0,
        "progression_free_survival":968.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":11.00603583,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":968.0,
        "Progression Free Survival Time":968.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06110":{
        "age":55,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":2.834552486,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06113":{
        "age":62,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":534.0,
        "PFS_event_status":1.0,
        "progression_free_survival":534.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":2.679537897,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":534.0,
        "Progression Free Survival Time":534.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06115":{
        "age":63,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":12.29044242,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06176":{
        "age":44,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1018.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1018.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":16.6751408,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1018.0,
        "Progression Free Survival Time":1018.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06193":{
        "age":47,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1076.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1076.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":3.321741195,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1076.0,
        "Progression Free Survival Time":1076.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06195":{
        "age":52,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1099.0,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":9.278730404,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":null,
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":null,
        "Overall Survival Time":1099.0,
        "Progression Free Survival Time":null,
        "ubi_cluster":null,
        "glyco cluster":"Other"
    },
    "C3L-06200":{
        "age":82,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":984.0,
        "PFS_event_status":0.0,
        "progression_free_survival":984.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":12.88835584,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":984.0,
        "Progression Free Survival Time":984.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06205":{
        "age":45,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":434.0,
        "PFS_event_status":1.0,
        "progression_free_survival":434.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"Yes",
        "TMB":8.01646875,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":434.0,
        "Progression Free Survival Time":434.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-06206":{
        "age":71,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1062.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1062.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":74.60630723,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1062.0,
        "Progression Free Survival Time":1062.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06207":{
        "age":64,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1036.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1036.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":23.09717377,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1036.0,
        "Progression Free Survival Time":1036.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06212":{
        "age":77,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":0.0,
        "overall_survival":2000.0,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":1.70516048,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":null,
        "SNF_group_of_interest":"other",
        "ICI_cluster":null,
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":null,
        "Overall Survival Time":2000.0,
        "Progression Free Survival Time":null,
        "ubi_cluster":null,
        "glyco cluster":null
    },
    "C3L-06217":{
        "age":44,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1309.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1309.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":1.904464952,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1309.0,
        "Progression Free Survival Time":1309.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06227":{
        "age":62,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":995.0,
        "PFS_event_status":0.0,
        "progression_free_survival":995.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":3.653915314,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":995.0,
        "Progression Free Survival Time":995.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-06299":{
        "age":71,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1099.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1099.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":15.78934315,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1099.0,
        "Progression Free Survival Time":1099.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06311":{
        "age":67,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":194.0,
        "PFS_event_status":1.0,
        "progression_free_survival":194.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":4.296118612,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":194.0,
        "Progression Free Survival Time":194.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06333":{
        "age":81,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":968.0,
        "PFS_event_status":0.0,
        "progression_free_survival":968.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":8.747251813,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":968.0,
        "Progression Free Survival Time":968.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06338":{
        "age":59,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":994.0,
        "PFS_event_status":0.0,
        "progression_free_survival":994.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":5.270496029,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":994.0,
        "Progression Free Survival Time":994.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06339":{
        "age":60,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":242.0,
        "PFS_event_status":1.0,
        "progression_free_survival":169.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":1.838030128,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP2",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":242.0,
        "Progression Free Survival Time":169.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3L-06340":{
        "age":60,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":967.0,
        "PFS_event_status":1.0,
        "progression_free_survival":224.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":18.18099681,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":967.0,
        "Progression Free Survival Time":224.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-06349":{
        "age":74,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Deceased",
        "event_status":1.0,
        "overall_survival":1131.0,
        "PFS_event_status":1.0,
        "progression_free_survival":206.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":39.52872022,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1131.0,
        "Progression Free Survival Time":206.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06395":{
        "age":62,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":323.0,
        "PFS_event_status":1.0,
        "progression_free_survival":192.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":1.970899776,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":323.0,
        "Progression Free Survival Time":192.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06424":{
        "age":71,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":205.0,
        "PFS_event_status":0.0,
        "progression_free_survival":205.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":11.316065,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":205.0,
        "Progression Free Survival Time":205.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06427":{
        "age":79,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":715.0,
        "PFS_event_status":0.0,
        "progression_free_survival":715.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":1.616580715,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":715.0,
        "Progression Free Survival Time":715.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06428":{
        "age":80,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":205.0,
        "PFS_event_status":0.0,
        "progression_free_survival":205.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":32.61949853,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"mutant",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":205.0,
        "Progression Free Survival Time":205.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06430":{
        "age":67,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":701.0,
        "PFS_event_status":0.0,
        "progression_free_survival":701.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":4.761162379,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":701.0,
        "Progression Free Survival Time":701.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3L-06433":{
        "age":68,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":17.87096763,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06435":{
        "age":63,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":1.129392006,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06715":{
        "age":70,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":4.318263553,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-06933":{
        "age":81,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":30.38285946,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"non-hotspot mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"mutant",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-07111":{
        "age":58,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":651.0,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":5.602670148,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":null,
        "Overall Survival Time":651.0,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-07548":{
        "age":81,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":293.0,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":0.775072945,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":null,
        "Overall Survival Time":293.0,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-07672":{
        "age":78,
        "sex":"Male",
        "tumor_stage":null,
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":223.0,
        "PFS_event_status":0.0,
        "progression_free_survival":223.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":25.46668249,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":223.0,
        "Progression Free Survival Time":223.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-07965":{
        "age":69,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":286.0,
        "PFS_event_status":0.0,
        "progression_free_survival":286.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":7.950033926,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":286.0,
        "Progression Free Survival Time":286.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-07966":{
        "age":64,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":315.0,
        "PFS_event_status":0.0,
        "progression_free_survival":315.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":5.071191557,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":315.0,
        "Progression Free Survival Time":315.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-08256":{
        "age":64,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":704.0,
        "PFS_event_status":1.0,
        "progression_free_survival":411.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":6.023424033,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":704.0,
        "Progression Free Survival Time":411.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-08259":{
        "age":44,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":665.0,
        "PFS_event_status":0.0,
        "progression_free_survival":665.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":13.39768949,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":665.0,
        "Progression Free Survival Time":665.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-08633":{
        "age":89,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":238.0,
        "PFS_event_status":0.0,
        "progression_free_survival":238.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":1.88232001,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":238.0,
        "Progression Free Survival Time":238.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-09062":{
        "age":90,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":344.0,
        "PFS_event_status":0.0,
        "progression_free_survival":344.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"Yes",
        "TMB":108.8202415,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":344.0,
        "Progression Free Survival Time":344.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3L-09223":{
        "age":81,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":null,
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":35.71979031,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"wildtype",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-09614":{
        "age":55,
        "sex":"Male",
        "tumor_stage":null,
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":5.248351088,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3L-09616":{
        "age":54,
        "sex":"Male",
        "tumor_stage":null,
        "tissue_level":"Primary",
        "vital_status":null,
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":4.539712966,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-00179":{
        "age":69,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":85.0,
        "PFS_event_status":1.0,
        "progression_free_survival":85.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":1.173681889,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":85.0,
        "Progression Free Survival Time":85.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-00209":{
        "age":81,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":40.0,
        "PFS_event_status":1.0,
        "progression_free_survival":40.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":18.31386645,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":40.0,
        "Progression Free Survival Time":40.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-00874":{
        "age":56,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":486.0,
        "PFS_event_status":1.0,
        "progression_free_survival":216.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":3.388176019,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":486.0,
        "Progression Free Survival Time":216.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-01481":{
        "age":73,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":null,
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":3.299596253,
        "BRAF_hotspot":"V600R",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-01493":{
        "age":34,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":null,
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":2.037334599,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-01494":{
        "age":64,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":null,
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":6.289163329,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-01495":{
        "age":49,
        "sex":"Female",
        "tumor_stage":null,
        "tissue_level":null,
        "vital_status":null,
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":2.72382778,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3N-01530":{
        "age":83,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":663.0,
        "PFS_event_status":0.0,
        "progression_free_survival":663.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":5.779829679,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":663.0,
        "Progression Free Survival Time":663.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-01533":{
        "age":76,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":1661.0,
        "PFS_event_status":1.0,
        "progression_free_survival":1661.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":18.33601139,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1661.0,
        "Progression Free Survival Time":1661.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-01824":{
        "age":59,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":1046.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1046.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":12.00255818,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1046.0,
        "Progression Free Survival Time":1046.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-01844":{
        "age":63,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":696.0,
        "PFS_event_status":0.0,
        "progression_free_survival":696.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":4.052524258,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":696.0,
        "Progression Free Survival Time":696.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Lysosome high"
    },
    "C3N-02026":{
        "age":80,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":71.0,
        "PFS_event_status":1.0,
        "progression_free_survival":71.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":4.739017438,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":71.0,
        "Progression Free Survival Time":71.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-02033":{
        "age":76,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":655.0,
        "PFS_event_status":1.0,
        "progression_free_survival":161.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":7.418555335,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":655.0,
        "Progression Free Survival Time":161.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-02035":{
        "age":64,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":80.0,
        "PFS_event_status":0.0,
        "progression_free_survival":80.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":14.68209608,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":80.0,
        "Progression Free Survival Time":80.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Lysosome high"
    },
    "C3N-02270":{
        "age":76,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":297.0,
        "PFS_event_status":1.0,
        "progression_free_survival":297.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":6.577047566,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":297.0,
        "Progression Free Survival Time":297.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3N-02324":{
        "age":45,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":0.0,
        "overall_survival":2000.0,
        "PFS_event_status":0.0,
        "progression_free_survival":2000.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":11.2053403,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":2000.0,
        "Progression Free Survival Time":2000.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-02327":{
        "age":46,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":859.0,
        "PFS_event_status":1.0,
        "progression_free_survival":322.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":1.284406595,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":859.0,
        "Progression Free Survival Time":322.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-02330":{
        "age":51,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":454.0,
        "PFS_event_status":1.0,
        "progression_free_survival":91.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":6.399888035,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":454.0,
        "Progression Free Survival Time":91.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-02335":{
        "age":77,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":2000.0,
        "PFS_event_status":0.0,
        "progression_free_survival":2000.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":2.745972721,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":2000.0,
        "Progression Free Survival Time":2000.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-02373":{
        "age":66,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":3.0,
        "PFS_event_status":0.0,
        "progression_free_survival":3.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":2.834552486,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":3.0,
        "Progression Free Survival Time":3.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3N-02633":{
        "age":55,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1861.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1861.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":8.902266402,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1861.0,
        "Progression Free Survival Time":1861.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03029":{
        "age":70,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":741.0,
        "PFS_event_status":1.0,
        "progression_free_survival":149.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":1.129392006,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":741.0,
        "Progression Free Survival Time":149.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03097":{
        "age":60,
        "sex":"Male",
        "tumor_stage":null,
        "tissue_level":null,
        "vital_status":null,
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":10.563137,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Lysosome high"
    },
    "C3N-03220":{
        "age":86,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":1.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":7.086381215,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1.0,
        "Progression Free Survival Time":1.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03223":{
        "age":54,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":312.0,
        "PFS_event_status":0.0,
        "progression_free_survival":312.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":5.29264097,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":312.0,
        "Progression Free Survival Time":312.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03228":{
        "age":32,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":888.0,
        "PFS_event_status":0.0,
        "progression_free_survival":888.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":5.62481509,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":888.0,
        "Progression Free Survival Time":888.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-03229":{
        "age":75,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":85.0,
        "PFS_event_status":0.0,
        "progression_free_survival":85.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":63.29024223,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":85.0,
        "Progression Free Survival Time":85.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03234":{
        "age":62,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":295.0,
        "PFS_event_status":0.0,
        "progression_free_survival":295.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"Yes",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":18.24743163,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":295.0,
        "Progression Free Survival Time":295.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-03235":{
        "age":53,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":289.0,
        "PFS_event_status":0.0,
        "progression_free_survival":289.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":3.676060255,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":289.0,
        "Progression Free Survival Time":289.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-03239":{
        "age":68,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":329.0,
        "PFS_event_status":0.0,
        "progression_free_survival":329.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":0.68649318,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP2",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":329.0,
        "Progression Free Survival Time":329.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03460":{
        "age":67,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":264.0,
        "PFS_event_status":0.0,
        "progression_free_survival":264.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":1.727305421,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":264.0,
        "Progression Free Survival Time":264.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03614":{
        "age":76,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":2.0,
        "PFS_event_status":0.0,
        "progression_free_survival":2.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":12.51189183,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":2.0,
        "Progression Free Survival Time":2.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03617":{
        "age":73,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":348.0,
        "PFS_event_status":0.0,
        "progression_free_survival":348.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":8.105048515,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"Q61",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":348.0,
        "Progression Free Survival Time":348.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03885":{
        "age":33,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":410.0,
        "PFS_event_status":0.0,
        "progression_free_survival":410.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":47.16872497,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"mutant",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":410.0,
        "Progression Free Survival Time":410.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-03913":{
        "age":45,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":209.0,
        "PFS_event_status":0.0,
        "progression_free_survival":209.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":10.36383253,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":209.0,
        "Progression Free Survival Time":209.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03916":{
        "age":74,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":53.0,
        "PFS_event_status":1.0,
        "progression_free_survival":53.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":9.079425932,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":53.0,
        "Progression Free Survival Time":53.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-03918":{
        "age":80,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":null,
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":13.3533996,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-04142":{
        "age":81,
        "sex":"Female",
        "tumor_stage":"StageI&II",
        "tissue_level":"Primary",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":224.0,
        "PFS_event_status":1.0,
        "progression_free_survival":122.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":6.067713916,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"prim_pmel",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":224.0,
        "Progression Free Survival Time":122.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-04156":{
        "age":47,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":null,
        "event_status":null,
        "overall_survival":null,
        "PFS_event_status":null,
        "progression_free_survival":null,
        "Radiation-therapy":null,
        "Chemo-therapy":null,
        "Immuno-therapy":null,
        "Targeted-therapy":null,
        "TMB":4.42898826,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":null,
        "Death or Progression":null,
        "Overall Survival Time":null,
        "Progression Free Survival Time":null,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-04293":{
        "age":75,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":245.0,
        "PFS_event_status":1.0,
        "progression_free_survival":245.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":14.10632761,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"met_pmel",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":245.0,
        "Progression Free Survival Time":245.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Lysosome high"
    },
    "C3N-04294":{
        "age":64,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":211.0,
        "PFS_event_status":1.0,
        "progression_free_survival":211.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":3.831074845,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":211.0,
        "Progression Free Survival Time":211.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-05101":{
        "age":76,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":581.0,
        "PFS_event_status":1.0,
        "progression_free_survival":324.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"Yes",
        "TMB":8.570092282,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":581.0,
        "Progression Free Survival Time":324.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-05106":{
        "age":71,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1314.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1314.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":18.57960575,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1314.0,
        "Progression Free Survival Time":1314.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-05107":{
        "age":59,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":783.0,
        "PFS_event_status":1.0,
        "progression_free_survival":133.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":8.990846167,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":783.0,
        "Progression Free Survival Time":133.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-05108":{
        "age":74,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1185.0,
        "PFS_event_status":1.0,
        "progression_free_survival":765.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":9.788064054,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1185.0,
        "Progression Free Survival Time":765.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-05623":{
        "age":58,
        "sex":"Male",
        "tumor_stage":"StageI&II",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":661.0,
        "PFS_event_status":1.0,
        "progression_free_survival":607.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":null,
        "TMB":2.081624482,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":661.0,
        "Progression Free Survival Time":607.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    },
    "C3N-05624":{
        "age":72,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1778.0,
        "PFS_event_status":1.0,
        "progression_free_survival":326.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":null,
        "TMB":13.95131302,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1778.0,
        "Progression Free Survival Time":326.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06042":{
        "age":37,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1117.0,
        "PFS_event_status":0.0,
        "progression_free_survival":1117.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"Yes",
        "TMB":4.650437673,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":1117.0,
        "Progression Free Survival Time":1117.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06044":{
        "age":65,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living|Living",
        "event_status":0.0,
        "overall_survival":1079.0,
        "PFS_event_status":1.0,
        "progression_free_survival":49.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"Yes",
        "TMB":3.565335549,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP2",
        "SNF_group_of_interest":"met_axl",
        "ICI_cluster":"EMT-like",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":1079.0,
        "Progression Free Survival Time":49.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06046":{
        "age":89,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Deceased",
        "event_status":1.0,
        "overall_survival":442.0,
        "PFS_event_status":1.0,
        "progression_free_survival":273.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":1.904464952,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":442.0,
        "Progression Free Survival Time":273.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06050":{
        "age":75,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":108.0,
        "PFS_event_status":1.0,
        "progression_free_survival":108.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":7.352120511,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"mutant",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":108.0,
        "Progression Free Survival Time":108.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06051":{
        "age":77,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":837.0,
        "PFS_event_status":0.0,
        "progression_free_survival":837.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":4.78330732,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"EMT-like",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":837.0,
        "Progression Free Survival Time":837.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06052":{
        "age":70,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":834.0,
        "PFS_event_status":0.0,
        "progression_free_survival":834.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"Yes",
        "TMB":5.159771322,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":834.0,
        "Progression Free Survival Time":834.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06053":{
        "age":89,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Deceased",
        "event_status":1.0,
        "overall_survival":228.0,
        "PFS_event_status":1.0,
        "progression_free_survival":182.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":2.768117662,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"mutant",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"death",
        "Death or Progression":"death/progression",
        "Overall Survival Time":228.0,
        "Progression Free Survival Time":182.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06054":{
        "age":84,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":837.0,
        "PFS_event_status":0.0,
        "progression_free_survival":837.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"Yes",
        "TMB":8.614382165,
        "BRAF_hotspot":"V600K",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":">76.0 (>75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":837.0,
        "Progression Free Survival Time":837.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06993":{
        "age":70,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":728.0,
        "PFS_event_status":0.0,
        "progression_free_survival":728.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":3.476755784,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_AP1",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"mutant",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"mutant",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":728.0,
        "Progression Free Survival Time":728.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06995":{
        "age":74,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":698.0,
        "PFS_event_status":0.0,
        "progression_free_survival":698.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":11.316065,
        "BRAF_hotspot":"non-hotspot mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":698.0,
        "Progression Free Survival Time":698.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06996":{
        "age":59,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":693.0,
        "PFS_event_status":0.0,
        "progression_free_survival":693.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"Yes",
        "TMB":13.84058831,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":693.0,
        "Progression Free Survival Time":693.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-06997":{
        "age":71,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":704.0,
        "PFS_event_status":1.0,
        "progression_free_survival":112.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"Yes",
        "TMB":1.70516048,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":704.0,
        "Progression Free Survival Time":112.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-07000":{
        "age":52,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":813.0,
        "PFS_event_status":1.0,
        "progression_free_survival":608.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":15.70076338,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":813.0,
        "Progression Free Survival Time":608.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-08031":{
        "age":38,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":866.0,
        "PFS_event_status":0.0,
        "progression_free_survival":866.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":3.897509668,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"mutant",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":866.0,
        "Progression Free Survival Time":866.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-08032":{
        "age":62,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":867.0,
        "PFS_event_status":1.0,
        "progression_free_survival":342.0,
        "Radiation-therapy":"Yes",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"Yes",
        "TMB":3.831074845,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"Ribo-high",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"59.0-69.5 (25%-50%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":867.0,
        "Progression Free Survival Time":342.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-08899":{
        "age":70,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Primary",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":755.0,
        "PFS_event_status":0.0,
        "progression_free_survival":755.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":16.12151727,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"Q61",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"mutant",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"mutant",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":755.0,
        "Progression Free Survival Time":755.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-08901":{
        "age":70,
        "sex":"Female",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":386.0,
        "PFS_event_status":0.0,
        "progression_free_survival":386.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"Yes",
        "Targeted-therapy":"No",
        "TMB":5.026901675,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"69.5-76.0 (50%-75%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":386.0,
        "Progression Free Survival Time":386.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-08902":{
        "age":46,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living|Living",
        "event_status":0.0,
        "overall_survival":698.0,
        "PFS_event_status":1.0,
        "progression_free_survival":75.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":6.244873446,
        "BRAF_hotspot":"V600E",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_M",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"mutant",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"mutant",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"death/progression",
        "Overall Survival Time":698.0,
        "Progression Free Survival Time":75.0,
        "ubi_cluster":"Baseline",
        "glyco cluster":"Other"
    },
    "C3N-09075":{
        "age":57,
        "sex":"Male",
        "tumor_stage":"StageIII&IV",
        "tissue_level":"Metastasis",
        "vital_status":"Living",
        "event_status":0.0,
        "overall_survival":371.0,
        "PFS_event_status":0.0,
        "progression_free_survival":371.0,
        "Radiation-therapy":"No",
        "Chemo-therapy":"No",
        "Immuno-therapy":"No",
        "Targeted-therapy":"No",
        "TMB":2.081624482,
        "BRAF_hotspot":"no mutation",
        "NRAS_hotspot":"no mutation",
        "KRAS_hotspot":"no mutation",
        "transcriptional_state_classification":"malignant_T",
        "SNF_group_of_interest":"other",
        "ICI_cluster":"ICI-sensitive",
        "ARID1A":"wildtype",
        "ARID2":"wildtype",
        "ATRX":"wildtype",
        "BRAF":"wildtype",
        "NRAS":"wildtype",
        "NF1":"wildtype",
        "TERT":"wildtype",
        "TP53":"wildtype",
        "age_group":"<59.0 (25%)",
        "cohort":"discovery",
        "Death":"alive",
        "Death or Progression":"alive without progression",
        "Overall Survival Time":371.0,
        "Progression Free Survival Time":371.0,
        "ubi_cluster":"IFN-UB",
        "glyco cluster":"Other"
    }
}